/* oxlint-disable */
'use client';

import { useCallback, useMemo, useRef } from 'react';

import { useRouter } from 'next/navigation';

import { getProviderCurrencyString } from '@/constants/providerCurrencies';
import { routes } from '@/features/v2/constants/routes';
import { UseRedirectGameProps } from '@/features/v2/home/components/CasinoSection/interface';
import { useAuthStore } from '@/stores/userStore';
import { userUIStore } from '@/stores/userUIStore';
import { hasValidFreeSpinForGame } from '@/utils/casinoFreeSpinAccess';
import { isGameCurrencyMismatch } from '@/utils/currency';

import { useAuth } from '@/core/auth/client/AuthProvider';

// const mapDynamicCategory = (category: string): string => {
//   const allCategoriesMapped: Record<string, string> = {
//     'Para ti': 'zing-para-ti',
//     'Porque te gusta': 'zing-porque-te-gusta',
//     'Nuevos juegos que te van a gustar': 'zing-nuevos-juegos-que-te-van-a-gustar',
//     'También te puede gustar': 'zing-tambien-te-puede-gustar',
//     'Juegos en tendencia': 'zing-juegos-en-tendencia',
//     'Tus favoritos olvidados': 'zing-tus-favoritos-olvidados',
//     'Tus favoritos': 'zing-tus-favoritos',
//   };

//   const dynamicCategoryPattern = /^Porque te gusta/;
//   if (dynamicCategoryPattern.test(category)) {
//     return 'zing-porque-te-gusta';
//   }
//   return allCategoriesMapped[category] || category;
// };

// const sendTrackingEvent = (url: string, payload: any) => {
//
//   void fetch(url, {
//     method: 'POST',
//     headers: { 'Content-Type': 'application/json' },
//     body: JSON.stringify(payload),
//   })
//     .then((res) => {
//       if (!res.ok) {
//         console.warn('Tracking failed:', res.statusText);
//       }
//     })
//     .catch((err) => { return console.warn('Tracking error:', err); });
// };

export const useRedirectGame = () => {
  const router = useRouter();
  const { session } = useAuth();
  const accountFullProfile = useAuthStore((state) => { return state.account?.fullProfile ?? false; });
  const userCurrency = useAuthStore((state) => { return state.account?.currency || 'USD'; });
  const balanceAmountRaw = useAuthStore((state) => { return state.balance?.[0]?.amount ?? 0; });
  const previousBalanceRef = useRef<number>(balanceAmountRaw);

  const balanceAmount = useMemo(() => {
    try {
      if (balanceAmountRaw !== previousBalanceRef.current) {
        previousBalanceRef.current = balanceAmountRaw;
        return balanceAmountRaw;
      }
      return previousBalanceRef.current;
    } catch (error) {
      console.warn('useRedirectGame balanceAmount error:', error);
      return 0;
    }
  }, [balanceAmountRaw]);

  const bonusSpins = useAuthStore((state) => { return state.bonuses?.spins; });

  const {
    toggleLoginModal,
    toggleDepositSheet,
    toggleDepositModal,
    toggleAcceptModal,
    setAlert,
  } = userUIStore();

  const handleGameRedirect = useCallback(async ({
    item,
    // categorySelected,
    // gameIndex = 0,
    setIsAcceptModalUrl,
    onCurrencyMismatch,
  }: UseRedirectGameProps) => {
    try {
      // const categoryToTrackingEvents = mapDynamicCategory(categorySelected);

      if (!session) {
        toggleLoginModal();
        return;
      }

      if (!accountFullProfile) {
        setAlert({
          type: 'warning', message: 'Debes completar tu perfil para jugar', show: true, duration: 3000,
        });
        return;
      }

      const gameCurrency = item.currency && item.currency.trim() !== ''
        ? item.currency
        : getProviderCurrencyString(item.producer);

      const numericBalance = Number(balanceAmount);
      const hasBalance = Number.isFinite(numericBalance) && numericBalance > 0;

      let canEnterGame = false;
      try {
        canEnterGame = hasBalance || hasValidFreeSpinForGame(bonusSpins, item.identifier);
      } catch (innerError) {
        console.warn('useRedirectGame freeSpin error:', innerError);
        canEnterGame = hasBalance;
      }

      const promptDeposit = (): void => {
        try {
          if (window.innerWidth < 1000) {
            router.push(routes.DEPOSIT);
          } else {
            toggleDepositModal();
          }
        } catch (error) {
          console.warn('useRedirectGame promptDeposit error:', error);
        }
      };

      if (isGameCurrencyMismatch(userCurrency, gameCurrency)) {
        // const eventPayload = {
        //   recommendationId: item.recommendationId || null,
        //   gameId: item.identifier,
        //   gameProviderId: item.provider,
        //   position: gameIndex.toString(),
        //   category: categoryToTrackingEvents || '',
        //   playerId: String(userId),
        // };

        // sendTrackingEvent('/api/casino/trackingEvents', eventPayload);

        if (!canEnterGame) {
          promptDeposit();
          return;
        }

        const fallbackCurrency = 'USD';
        const modalUrl = `/casino/play?provider=${item.provider}&gamecode=${item.identifier}`;
        if (onCurrencyMismatch) {
          onCurrencyMismatch({
            url: modalUrl,
            originalCurrency: userCurrency,
            fallbackCurrency,
          });
          return;
        }

        if (setIsAcceptModalUrl) {
          toggleAcceptModal();
          setIsAcceptModalUrl(modalUrl);
          return;
        }
        router.push(modalUrl);
        return;
      }

      if (!canEnterGame) {
        promptDeposit();
        return;
      }

      // const eventPayload = {
      //   recommendationId: item.recommendationId || null,
      //   gameId: item.identifier,
      //   gameProviderId: item.provider,
      //   position: gameIndex.toString(),
      //   category: categoryToTrackingEvents || '',
      //   playerId: String(userId),
      // };

      // sendTrackingEvent('/api/casino/trackingEvents', eventPayload);

      router.push(`/casino/play?provider=${item.provider}&gamecode=${item.identifier}`);
    } catch (error) {
      console.warn('useRedirectGame handleGameRedirect error:', error);
    }
  }, [
    session,
    accountFullProfile,
    userCurrency,
    balanceAmount,
    bonusSpins,
    router,
    toggleLoginModal,
    toggleDepositSheet,
    toggleDepositModal,
    toggleAcceptModal,
    setAlert,
  ]);

  return {
    handleGameRedirect,
  };
};